<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/booking.webp"
  >
    <ng-container i18n>
      Bookings represent guest reservations for a property, including actions from inquiry to post-check-out. This
      includes tasks like confirming bookings, sending reminders, updating statuses, and managing cancellations. The
      booking entity ensures a seamless guest experience from reservation to departure.
    </ng-container>
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 pb-4 bg-default2">
      <h6 i18n>What would you like to do when:</h6>

      <div class="d-flex gap-3" [formGroup]="form">
        <mat-form-field2 [showLabel]="false">
          <mat-select formControlName="event">
            <mat-option [value]="events.InquiryCreated" i18n> Inquiry is Created</mat-option>
            <mat-option [value]="events.BookingConfirmed" i18n> Booking is Confirmed</mat-option>
            <mat-option [value]="events.BookingCanceled" i18n> Booking is Canceled</mat-option>
            <mat-option [value]="events.BookingDatesUpdated" i18n> Booking Dates are Changed</mat-option>
            <mat-option [value]="events.BookingRentalUpdated" i18n> Booking Rental is Changed</mat-option>
            <mat-option [value]="events.BookingGuestUpdated" i18n> Booking Guest is Changed</mat-option>
            <mat-option [value]="events.BookingCostUpdated" i18n> Booking Cost is Changed</mat-option>
            <mat-option [value]="events.BookingIsPaid" i18n> Booking is Paid</mat-option>
            <mat-option [value]="events.TimeBeforeBookingCheckIn" i18n> Before Check-in</mat-option>
            <mat-option [value]="events.TimeAfterBookingCheckIn" i18n> After Check-in</mat-option>
            <mat-option [value]="events.TimeBeforeBookingCheckout" i18n> Before Check-out</mat-option>
            <mat-option [value]="events.TimeAfterBookingCheckout" i18n>After Check-out</mat-option>
          </mat-select>
        </mat-form-field2>

        <ng-container *ngIf="isTimeEvent">
          <app-automation-time-options
            [form]="form"
            [showLabel]="false"
            class="d-flex gap-3"
          ></app-automation-time-options>
        </ng-container>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <div class="alert alert-secondary-warning2 mb-0" *ngIf="selectedEvent == events.TimeBeforeBookingCheckIn">
        <i class="far fa-exclamation-triangle alert-icon"></i>
        <div class="alert-content" i18n>
          Above days/hours settings do not apply to both <b>Send a pre-arrival message to the guest</b> and
          <b>Send a check-in welcome message to guest</b>
        </div>
      </div>

      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.InquiryCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingConfirmed" [ngTemplateOutlet]="confirmedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingCanceled" [ngTemplateOutlet]="canceledEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingDatesUpdated" [ngTemplateOutlet]="datesUpdatedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingRentalUpdated" [ngTemplateOutlet]="rentalUpdatedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingGuestUpdated" [ngTemplateOutlet]="guestUpdatedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingCostUpdated" [ngTemplateOutlet]="costUpdatedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.BookingIsPaid" [ngTemplateOutlet]="paidEvent"></ng-template>
        <ng-template *ngSwitchCase="events.TimeBeforeBookingCheckIn" [ngTemplateOutlet]="beforeCheckIn"></ng-template>
        <ng-template *ngSwitchCase="events.TimeAfterBookingCheckIn" [ngTemplateOutlet]="afterCheckIn"></ng-template>
        <ng-template *ngSwitchCase="events.TimeBeforeBookingCheckout" [ngTemplateOutlet]="beforeCheckOut"></ng-template>
        <ng-template *ngSwitchCase="events.TimeAfterBookingCheckout" [ngTemplateOutlet]="afterCheckOut"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select [form]="form"></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Inquiry is Created</h6>
    <ng-template [ngTemplateOutlet]="createdEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking is Confirmed</h6>
    <ng-template [ngTemplateOutlet]="confirmedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking is Canceled</h6>
    <ng-template [ngTemplateOutlet]="canceledEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking Dates is Changed</h6>
    <ng-template [ngTemplateOutlet]="datesUpdatedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking Rental is Changed</h6>
    <ng-template [ngTemplateOutlet]="rentalUpdatedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking Guest is Changed</h6>
    <ng-template [ngTemplateOutlet]="guestUpdatedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking Cost is Changed</h6>
    <ng-template [ngTemplateOutlet]="costUpdatedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Booking is Paid</h6>
    <ng-template [ngTemplateOutlet]="paidEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Before Check-in</h6>
    <ng-template [ngTemplateOutlet]="beforeCheckIn"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>After Check-in</h6>
    <ng-template [ngTemplateOutlet]="afterCheckIn"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Before Check-out</h6>
    <ng-template [ngTemplateOutlet]="beforeCheckOut"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>After Check-out</h6>
    <ng-template [ngTemplateOutlet]="afterCheckOut"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <app-notify-guest-automation
    [event]="events.InquiryCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the potential guest with options for next steps"
    [messageSubject]="guestNotificationMessages[events.InquiryCreated].subject"
    [messageBody]="guestNotificationMessages[events.InquiryCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.InquiryCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of the new inquiry"
    [messageSubject]="userNotificationMessages[events.InquiryCreated].subject"
    [messageBody]="userNotificationMessages[events.InquiryCreated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-document-automation
    [event]="events.InquiryCreated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign when inquiry created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.InquiryCreated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking created"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #confirmedEvent>
  <app-do-action-automation
    [event]="events.BookingConfirmed"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkPaid"
    i18n-label
    label="Mark booking as paid"
    i18n-name
    name="Mark booking as paid when booking confirmed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-guest-automation
    [event]="events.BookingConfirmed"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the guest of the confirmation"
    [messageSubject]="guestNotificationMessages[events.BookingConfirmed].subject"
    [messageBody]="guestNotificationMessages[events.BookingConfirmed].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.BookingConfirmed"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of confirmed booking"
    [messageSubject]="userNotificationMessages[events.BookingConfirmed].subject"
    [messageBody]="userNotificationMessages[events.BookingConfirmed].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-document-automation
    [event]="events.BookingConfirmed"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign when booking confirmed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.BookingConfirmed"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking confirmed"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #canceledEvent>
  <app-notify-guest-automation
    [event]="events.BookingCanceled"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the guest of the cancellation"
    [messageSubject]="guestNotificationMessages[events.BookingCanceled].subject"
    [messageBody]="guestNotificationMessages[events.BookingCanceled].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.BookingCanceled"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the user(s) of the cancellation"
    [messageSubject]="userNotificationMessages[events.BookingCanceled].subject"
    [messageBody]="userNotificationMessages[events.BookingCanceled].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-do-action-automation
    [event]="events.BookingCanceled"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking canceled"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #datesUpdatedEvent>
  <app-notify-guest-automation
    [event]="events.BookingDatesUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the guest of the date changes"
    [messageSubject]="guestNotificationMessages[events.BookingDatesUpdated].subject"
    [messageBody]="guestNotificationMessages[events.BookingDatesUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.BookingDatesUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of the dates changes "
    [messageSubject]="userNotificationMessages[events.BookingDatesUpdated].subject"
    [messageBody]="userNotificationMessages[events.BookingDatesUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-task-automation
    [event]="events.BookingDatesUpdated"
    [handler]="eventHandlers.BookingCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [task]="taskAfterDatesChanged"
    i18n-label
    label="Create task and assign to assignee"
    i18n-name
    name="Create task and assign to assignee when dates are updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>

  <app-do-action-automation
    [event]="events.BookingDatesUpdated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingRemoveTaskHandler"
    i18n-label
    label="Remove all existing tasks for this booking"
    i18n-name
    name="Remove all existing tasks for this booking when dates are updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
  <app-do-action-automation
    [event]="events.BookingDatesUpdated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking dates are updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #rentalUpdatedEvent>
  <app-notify-guest-automation
    [event]="events.BookingRentalUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the guest of the rental change"
    i18n-name
    name="Notify the guest of the rental change when rental is updated"
    [messageSubject]="guestNotificationMessages[events.BookingRentalUpdated].subject"
    [messageBody]="guestNotificationMessages[events.BookingRentalUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.BookingRentalUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of the rental change"
    i18n-name
    name="Notify user(s) of the rental change when rental is updated"
    [messageSubject]="userNotificationMessages[events.BookingRentalUpdated].subject"
    [messageBody]="userNotificationMessages[events.BookingRentalUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-task-automation
    [event]="events.BookingRentalUpdated"
    [handler]="eventHandlers.BookingCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [task]="taskAfterRentalChanged"
    i18n-label
    label="Create task and assign to assignee"
    i18n-name
    name="Create task and assign to assignee when rental is updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>

  <app-do-action-automation
    [event]="events.BookingRentalUpdated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingRemoveTaskHandler"
    i18n-label
    label="Remove all existing tasks for this booking"
    i18n-name
    name="Remove all existing tasks for this booking when rental is updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
  <app-do-action-automation
    [event]="events.BookingRentalUpdated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking rental is updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #guestUpdatedEvent>
  <app-notify-guest-automation
    [event]="events.BookingGuestUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the new guest of the booking"
    i18n-name
    name="Notify the new guest of the booking when guest is updated"
    [messageSubject]="guestNotificationMessages[events.BookingGuestUpdated].subject"
    [messageBody]="guestNotificationMessages[events.BookingGuestUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.BookingGuestUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of the new guest"
    i18n-name
    name="Notify user(s) of the new guest when guest is updated"
    [messageSubject]="userNotificationMessages[events.BookingGuestUpdated].subject"
    [messageBody]="userNotificationMessages[events.BookingGuestUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
  <app-do-action-automation
    [event]="events.BookingGuestUpdated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking guest is updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #costUpdatedEvent>
  <app-notify-guest-automation
    [event]="events.BookingCostUpdated"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the guest of change"
    i18n-name
    name="Notify the guest of change when cost is updated"
    [messageSubject]="guestNotificationMessages[events.BookingCostUpdated].subject"
    [messageBody]="guestNotificationMessages[events.BookingCostUpdated].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
  <app-do-action-automation
    [event]="events.BookingCostUpdated"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking cost is updated"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #paidEvent>
  <app-notify-guest-automation
    [event]="events.BookingIsPaid"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the guest of payment receipt"
    i18n-name
    name="Notify the guest of payment receipt when booking is paid"
    [messageSubject]="guestNotificationMessages[events.BookingIsPaid].subject"
    [messageBody]="guestNotificationMessages[events.BookingIsPaid].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.BookingIsPaid"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) of booking"
    i18n-name
    name="Notify user(s) of booking when booking is paid"
    [messageSubject]="userNotificationMessages[events.BookingIsPaid].subject"
    [messageBody]="userNotificationMessages[events.BookingIsPaid].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-task-automation
    [event]="events.BookingIsPaid"
    [handler]="eventHandlers.BookingCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    [task]="taskAfterPaid"
    i18n-label
    label="Create task and assign to assignee"
    i18n-name
    name="Create task and assign to assignee when booking is paid"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>
  <app-do-action-automation
    [event]="events.BookingIsPaid"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when booking is paid"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #beforeCheckIn>
  <app-notify-guest-automation
    [event]="events.TimeBeforeBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send a pre-arrival message to guest"
    i18n-name
    name="Send a pre-arrival message to the guest with instructions and arrival time details"
    idSuffix="send-guest-checkin-instructions"
    [messageSubject]="guestNotificationMessages[events.TimeBeforeBookingCheckIn].subject"
    [messageBody]="guestNotificationMessages[events.TimeBeforeBookingCheckIn].message"
    customTooltip="Send pre-arrival instructions along arrival time details to guest"
    i18n-customTooltip
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [lateBookings]="true"
    [isTimeEditable]="true"
  ></app-notify-guest-automation>

  <app-notify-guest-automation
    [event]="events.TimeBeforeBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send a check-in welcome message to guest."
    i18n-name
    name="Send a check-in welcome message to guest"
    idSuffix="send-guest-welcome"
    [messageSubject]="guestNotificationMessages[events.TimeBeforeBookingCheckIn + '-send-guest-welcome'].subject"
    [messageBody]="guestNotificationMessages[events.TimeBeforeBookingCheckIn + '-send-guest-welcome'].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [lateBookings]="true"
    [isTimeEditable]="true"
  ></app-notify-guest-automation>

  <app-notify-guest-automation
    [event]="events.TimeBeforeBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send guest portal link"
    i18n-name
    name="Send guest portal link before check-in"
    [messageSubject]="guestNotificationMessages[events.TimeBeforeBookingCheckIn + '-send-guest-link'].subject"
    [messageBody]="guestNotificationMessages[events.TimeBeforeBookingCheckIn + '-send-guest-link'].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [lateBookings]="true"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.TimeBeforeBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) to prepare the property for guest arrival (cleaning, supplies, etc.)"
    [messageSubject]="userNotificationMessages[events.TimeBeforeBookingCheckIn].subject"
    [messageBody]="userNotificationMessages[events.TimeBeforeBookingCheckIn].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
    [lateBookings]="true"
  ></app-notify-users-automation>

  <app-new-document-automation
    [event]="events.TimeBeforeBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign before check-in"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.TimeBeforeBookingCheckIn"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier before check-in"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #afterCheckIn>
  <app-notify-guest-automation
    [event]="events.TimeAfterBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send a message to the guest to confirm a smooth check-in and offer assistance"
    [messageSubject]="guestNotificationMessages[events.TimeAfterBookingCheckIn].subject"
    [messageBody]="guestNotificationMessages[events.TimeAfterBookingCheckIn].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.TimeAfterBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the user(s) that the guest has successfully checked in"
    [messageSubject]="userNotificationMessages[events.TimeAfterBookingCheckIn].subject"
    [messageBody]="userNotificationMessages[events.TimeAfterBookingCheckIn].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-document-automation
    [event]="events.TimeAfterBookingCheckIn"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign after check-in"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.TimeAfterBookingCheckIn"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier after check-in"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #beforeCheckOut>
  <app-notify-guest-automation
    [event]="events.TimeBeforeBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send a reminder to the guest about check-out procedures and times"
    [messageSubject]="guestNotificationMessages[events.TimeBeforeBookingCheckout].subject"
    [messageBody]="guestNotificationMessages[events.TimeBeforeBookingCheckout].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-new-task-automation
    [event]="events.TimeBeforeBookingCheckout"
    [handler]="eventHandlers.BookingCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Schedule any necessary services (e.g., cleaning, maintenance) for after check-out"
    [task]="taskBeforeCheckout"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>

  <app-notify-users-automation
    [event]="events.TimeBeforeBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify the user(s) to prepare for guest departure (cleaning, inspections, etc.)"
    [messageSubject]="userNotificationMessages[events.TimeBeforeBookingCheckout].subject"
    [messageBody]="userNotificationMessages[events.TimeBeforeBookingCheckout].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-new-document-automation
    [event]="events.TimeBeforeBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign before check-out"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>

  <app-do-action-automation
    [event]="events.TimeBeforeBookingCheckout"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier before check-out"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #afterCheckOut>
  <app-notify-guest-automation
    [event]="events.TimeAfterBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send a thank-you message to the guest and invite them to leave a review"
    [messageSubject]="guestNotificationMessages[events.TimeAfterBookingCheckout].subject"
    [messageBody]="guestNotificationMessages[events.TimeAfterBookingCheckout].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-new-task-automation
    [event]="events.TimeAfterBookingCheckout"
    [handler]="eventHandlers.BookingCreateTaskHandler"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Schedule follow-up actions, such as damage inspections or feedback requests"
    [task]="taskAfterCheckout"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-task-automation>

  <app-new-review-automation
    id="review-after-checkout"
    [event]="events.TimeAfterBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Send review to Guest"
    i18n-name
    name="Send review to Guest after checkout"
    idSuffix="send-guest-review"
    [isTimeEditable]="true"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
  ></app-new-review-automation>

  <app-notify-users-automation
    [event]="events.TimeAfterBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) that the guest has officially checked out"
    [messageSubject]="userNotificationMessages[events.TimeAfterBookingCheckout].subject"
    [messageBody]="userNotificationMessages[events.TimeAfterBookingCheckout].message"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <app-do-action-automation
    [event]="events.TimeAfterBookingCheckout"
    [type]="automationTypes.Rental"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.RentalMarkNotReadyHandler"
    i18n-label
    label="Set the rental status to Not Ready"
    i18n-name
    name="Set the rental status to Not Ready after checkout"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
  <app-do-action-automation
    [event]="events.TimeAfterBookingCheckout"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier after check-out"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-new-document-automation
    [event]="events.TimeAfterBookingCheckout"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send Document to Sign"
    name="Send document to sign after check-out"
    [days]="form.get('days').value"
    [hours]="form.get('hours').value"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-new-document-automation>
</ng-template>
